





















































import { Vue, Component } from "vue-property-decorator";
import { ComponentBaseMixin } from "@/mixins/component-base.mixin";
import { mixins } from "vue-class-component";
import { formatDateTime } from "@/utils/formatters";
import {State} from "vuex-class";

@Component({ name: "posete" })
export default class Posete extends mixins(ComponentBaseMixin) {
    visits = [];
    merchandisers = [];
    isBusySearch = false;

    fromDate = "";
    toDate = "";
    selectedMerchandiser = "";
    store: any = "";

    columns = [];
    tableOptions = {
        pagination: true,
        sortable: true,
        onClickRow: (row) => this.onClickRow(row),
    };

    @State user;

    created() {
        this.columns = [
            {
                field: "managerReplied",
                formatter: (value) =>
                    value ? '<i class="ace-icon far fa-comment"></i>' : "",
            },
            {
                field: "date",
                title: this.$i18n.t("datum"),
                formatter: (value) => formatDateTime(value),
            },
            {
                field: "visitDuration",
                title: this.$i18n.t("trajanjePosete"),
                formatter: (value) => (value ? `${value} min` : "-"),
            },
            {
                field: "user",
                title: this.$i18n.t("merchandiser"),
                align: "left",
            },
            {
                field: "store",
                title: this.$i18n.t("objekat"),
                align: "left",
            },
            {
                field: "city",
                title: this.$i18n.t("mesto"),
                align: "left",
            },
        ];
        this.axios.get("api/GetUsers").then((result) => {
            this.merchandisers = result.data;
        });
    }

    async mounted() {
        let picker = $("#daterange");
        picker
            .daterangepicker({
                format: this.$i18n.t("DATE_FORMAT"),
                autoApply: true,
            })
            .data("daterangepicker")
            .setStartDate(new Date());

        $("#select2-posete").select2({
            placeholder: "-",
            width: "100%",
            allowClear: true,
            minimumInputLength: 3,
            ajax: {
                url: "api/SearchStoresByName",
                data: function(term) {
                    return { name: term.term || "" };
                },
                headers: {'X-User': this.user.id},
                processResults: function(data) {
                    return {
                        results: data.map(function(store) {
                            return {
                                id: store.id,
                                text: `${store.name} (${store.city})`,
                            };
                        }),
                    };
                },
            },
        });
    }

    async search() {
        if (this.isBusySearch) return;
        this.visits = [];
        let picker = $("#daterange");
        this.fromDate = picker
            .data("daterangepicker")
            .startDate.format("YYYY-MM-DD");
        this.toDate = picker
            .data("daterangepicker")
            .endDate.format("YYYY-MM-DD");
        this.store = $("#select2-posete").select2("val");

        let table = $("#bootstrapTable");
        table.bootstrapTable("showLoading");
        this.isBusySearch = true;
        await this.axios
            .get("api/GetVisits", {
                params: {
                    fromDate: this.fromDate,
                    toDate: this.toDate,
                    merchandiser: this.selectedMerchandiser || "",
                    store: this.store || "",
                },
            })
            .then((result) => {
                this.visits = result.data;
            })
            .catch((err) => {
                this.showError("neuspesnoUcitavanjePodataka");
                this.isBusySearch = false;
                table.bootstrapTable("hideLoading");
            })
            .finally(() => {
                this.isBusySearch = false;
                table.bootstrapTable("hideLoading");
            });
    }

    onClickRow(row) {
        this.$router.push({
            name: "poseta",
            params: { publicVisitID: row.publicId },
        });
    }
}
